import { render, staticRenderFns } from "./RelativeContract.vue?vue&type=template&id=464f1eaf&scoped=true"
import script from "./RelativeContract.vue?vue&type=script&lang=js"
export * from "./RelativeContract.vue?vue&type=script&lang=js"
import style0 from "./RelativeContract.vue?vue&type=style&index=0&id=464f1eaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464f1eaf",
  null
  
)

export default component.exports